<template>
  <div class="roleadd-box">
    <el-form :model="ruleForm" :rules="rules" ref="formName" label-position="left">
      <el-form-item label="名称" prop="examName">
        <el-input v-model="ruleForm.examName" autocomplete="off"></el-input>
      </el-form-item>

      <div class="quanxian-box">
        <div class="quanxian-le">
          <div class="tile-le"><span class="bi-tian"> * </span> 权限</div>
        </div>
        <div class="quanxian-rig">
          <!--注意：v-for需添加key，避免Vue警告-->
          <ul v-for="item in listData " :key="item.id || index" class="privilege-level1">
            <div class="biaoti-tile-rig">{{ item.name }}</div>
            <li class="duoxuan-min-box">
              <!-- 权限多选组：绑定已选ID数组 -->
              <el-checkbox-group v-model="checkList" @change="duoxuan">
                <!-- 第二层循环：修复key参数，补全循环索引 -->
                <div v-for="(item2, idx2) in item.children" :key="item2.id || idx2" class="privilege-level2">
                  <el-checkbox :label="item2.id" @change="(val) => handleParentCheck(val, item2)" ><span class="big-title-name">{{ item2.name }}</span></el-checkbox>
                  <!-- 第三层循环：key优先使用唯一id，保持结构统一 -->
                  <div class="zi-box" v-if="item2.children && item2.children.length">
                    <!--第三层循环添加key-->
                    <el-checkbox :label="item3.id" v-for="(item3,idx3) in item2.children" :key="item3.id || idx3" class="privilege-level3" @change="(val) => handleParentCheck(val, item3)">
                      {{ item3.name }}
                      <div class="zi-box level4" v-if="item3.children && item3.children.length">
                        <el-checkbox :label="item4.id" v-for="(item4, idx4) in item3.children" :key="item4.id || idx4" class="privilege-level4">
                          {{ item4.name }}
                        </el-checkbox>
                      </div>

                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div>

      <div class="buttom-box">
        <el-button type="primary" @click="submitForm('formName')">提交</el-button>
        <el-button @click="handleClose">返回</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { loadAllPrivileges,savePrivileges, } from '@/assets/api/user.js'

export default {
  props: ['xiugaiItem','titleValue'],
  name: '',
  components: {

  },
  data() {
    return {
      ruleForm: {
        examName: '',
      },
      listData: [],
      checkList: [],
      rules: {
        examName: [
          { required: true, message: '请输入名称', trigger: 'change' }
        ],
      }

    }
  },
  created() {
    // console.log(this.xiugaiItem,888888888888888);
    if (this.titleValue == '修改系统角色') {
      this.ruleForm.examName = this.xiugaiItem.name
    }
    this.loadAllPrivileges()
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    duoxuan () {
      console.log(this.checkList,'多选');
    },

    // 核心：处理父节点勾选/取消，实现父子联动
    handleParentCheck(isChecked, node) {
      if (!node?.children || node.children.length === 0) return;
      // 获取当前节点所有子节点ID（递归）
      const childIds = this.getAllChildIds(node);
      if (isChecked) {
        // 勾选父节点：添加所有子节点ID（去重）
        this.checkList = [...new Set([...this.checkList, ...childIds])];
      } else {
        // 取消父节点：移除所有子节点ID
        this.checkList = this.checkList.filter(id => !childIds.includes(id));
      }
    },

    // 递归获取节点所有子节点ID（支持无限层级）
    getAllChildIds(node) {
      let ids = [];
      if (node?.children && node.children.length > 0) {
        node.children.forEach(child => {
          ids.push(child.id);
          // 递归子节点
          ids = [...ids, ...this.getAllChildIds(child)];
        });
      }
      return ids;
    },

    // 递归收集所有usedByUser为true的权限Id
    collectCheckedIds(data){
      const checkedIds = [];
      //边界处理:如果数据不是数组直接返回空
      if (!Array.isArray(data) || data.length === 0) return checkedIds;
      //遍历第一次权限
      data.forEach(item => {

        // 若当前节点有usedByUser且为true，收集ID（兼容单层节点）
        if (item.usedByUser === true && item.id) {
          checkedIds.push(item.id)
        }
        // 递归处理子节点：无论多少层，自动遍历
        if (item.children && Array.isArray(item.children)) {
          checkedIds.push(...this.collectCheckedIds(item.children))
        }

      });
      return checkedIds;
    },

    //  校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if ( this.checkList.length > 0 ) {
            console.log(valid, '校验通过');
            if (this.titleValue == '新增系统角色') {
              this.savePrivilegesClick()
            } else if (this.titleValue == '修改系统角色') {
              // console.log('修改提交******');
              this.savePrivilegesClick()
              
            }
          } else {
            this.$message({
            type: 'error',
            message: '未选择权限，请选择权限!'
          });
          }
        } else {
          console.log(valid, '未通过');
        }
      });
    },
    handleClose() {
      this.$emit('fanhui')
    },
    //修改

    //新增
    savePrivilegesClick () {
      console.log( this.checkList);
      let params ={
        authorities: this.checkList,
        name: this.ruleForm.examName,
        roleId: this.xiugaiItem.id || ''
      }
      savePrivileges(params).then((res)=> {
        console.log(res);
        this.handleClose()
        this.$message({
          type: 'success',
          // message: '创建成功!'
          message:this.titleValue === '新增权限'?'创建成功！':'修改成功！'//区分新增/修改提示
        }); 
      }).catch((err)=> {
        console.log(err);
        this.$message({
          type:'error',
          message:'操作失败，请重试！'
        });
      })
    },
    // 加载菜单权限
    loadAllPrivileges() {
      const params = {
        roleId: this.xiugaiItem.id || '',
      }
      loadAllPrivileges(params).then((res) => {
        this.listData = res.data.data
        console.log(res, '权限111');
        //收集所有usedByUser为true的ID，赋值给checklist实现默认勾选
        this.checkList = this.collectCheckedIds(this.listData)
        console.log('权限数据：',res,'默认勾选的ID：',this.checkList);
      }).catch((err) => {
        console.log(err, '22222');
        this.$message({
          type:'error',
          message:'加载权限列表失败，请重试！'
        });
      })
    },
  }
};
</script>
<style lang='scss' scoped>
.roleadd-box {
  padding: 30px 20px 20px;
  height: 100%;
  overflow: auto;
  background-color: #fff;
  border-radius: 15px;

  // 权限选择区域整体布局
  .quanxian-box {
    display: flex;
    margin: 20px 0;

    // 权限左侧标题
    .quanxian-le {
      width: 140px;
      height: 40px;
      position: relative;

      .tile-le {
        position: absolute;
        top: 50%;
        left: 25px;
        transform: translate(0, -50%);
        font-size: 18px;
        font-weight: 700;
        color: var(--el-text-color-regular);

        .bi-tian {
          color: red;
          margin-right: 4px;
        }
      }
    }

    // 权限右侧选择区域
    .quanxian-rig {
      width: calc(100% - 140px);

      // 一级权限标题
      .privilege-level1 {
        list-style: none;
        padding: 0;
        margin: 0 0 15px 0;

        .biaoti-tile-rig {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 8px;
        }

        // 权限选择容器
        .duoxuan-min-box {
          margin-left: 45px;
          padding: 20px;
          background-color: #fafafa;
          border-radius: 8px;

          // 二级权限
          .privilege-level2 {
            display: block;
            margin-bottom: 10px;

            .big-title-name {
              font-size: 16px;
              font-weight: 500;
            }

            // 三级权限容器
            .zi-box {
              margin-left: 45px;
              margin-top: 5px;
              display: flex;
              flex-wrap: wrap;
              gap: 15px 20px;
              margin-bottom: 0;

              // 三级权限复选框
              .privilege-level3 {
                margin: 0;
              }

              // 新增：第四层权限容器样式
              &.level4 {
                margin-left: 45px; // 比三级再缩进45px，保持层级
                margin-top: 5px;
                margin-bottom: 0; // 取消底部外边距，避免层级间距过大
              }
            }
          }
        }
      }
    }
  }

  // 按钮区域
  .buttom-box {
    text-align: right;
    padding-right: 20px;
    margin-top: 30px;
  }
}

// 样式穿透：统一使用/deep/（Vue2标准），移除冗余!important
:deep() {
  // 表单标签样式
  .el-form-item--small .el-form-item__label {
    height: 35px;
    line-height: 35px;
    padding-left: 25px;
    font-size: 18px;
    font-weight: 700;
  }

  // 小尺寸输入框样式
  .el-input--small .el-input__wrapper {
    height: 35px;
    line-height: 35px;
    width: 280px;
  }

  // 复选框样式
  .el-checkbox--small .el-checkbox__label {
    font-size: 14px;
  }

  // 按钮样式：统一间距
  .el-button {
    margin-left: 10px;
  }

  // 可选：第四层复选框字体稍小，进一步区分层级
  .privilege-level4 .el-checkbox__label {
    font-size: 13px;
  }

}
</style>